module.exports = __webpack_public_path__ + "img/tick.4c7cd29a.svg";